const addAccessTokenToUrl = (url) => {
    let token = localStorage.getItem("access_token");
    return url + `?access_token=${token}`;
};

export default addAccessTokenToUrl;


// WEBPACK FOOTER //
// ./src/new/Utils/Axios/addTokenToUrl.js